import './index.css'

const ScoreCard = ({score, onPlayAgain}) => (
  <div className="scorecard-bg">
    <img
      src="https://assets.ccbp.in/frontend/react-js/match-game-trophy.png"
      alt="trophy"
      className="trophy-img"
    />
    <p className="game-over-text">YOUR SCORE</p>
    <p className="score-value">{score}</p>
    <button type="button" className="play-again-button" onClick={onPlayAgain}>
      <img
        src="https://assets.ccbp.in/frontend/react-js/match-game-play-again-img.png"
        alt="reset"
        className="reset-icon"
      />
      PLAY AGAIN
    </button>
  </div>
)

export default ScoreCard
